import { useQuery } from "@tanstack/react-query";

import { UsStatesEnumType } from "@libs/api/patients";
import { usePatientUSState } from "@/hooks/usePatientUSState";

import { HealthPlansApi } from "../api/healthPlansApi";

export const HealthPlansQueryKeys = {
  all: ["healthPlans"] as const,
  availability: (usState: UsStatesEnumType) =>
    [...HealthPlansQueryKeys.all, "availability", usState] as const,
};

export const useHealthPlanAvailabilityQuery = () => {
  const usState = usePatientUSState();

  return useQuery({
    queryKey: HealthPlansQueryKeys.availability(usState!),
    queryFn: () =>
      HealthPlansApi.getHealthPlanAvailability({ usState: usState! }),
    enabled: Boolean(usState),
    staleTime: Infinity,
  });
};
